// Follow-up suggestions. Model-authored per turn, then filtered server-side — see
// sanitizeSuggestions, which drops generic filler and anything this app cannot do.

export function Chips({ chips, onChip }: { chips: string[]; onChip: (text: string) => void }) {
  if (!chips.length) return null;
  return (
    <div className="chips">
      {chips.map((c, i) => (
        <button key={i} type="button" className="chip" onClick={() => onChip(c)}>
          {c}
        </button>
      ))}
    </div>
  );
}
